export default "__VITE_ASSET__966cc367__"